import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { BILLING_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { ExpenseApprovePage } from '@/features/billing/pages/ExpenseApprovePage';
import { expenseApprovalSearchSchema } from '@/features/billing/types/billing.types';

export const Route = createFileRoute('/_auth/billing/expense-approve')({
  beforeLoad: () => requirePermission(BILLING_PERMISSIONS.APPROVAL_VIEW),
  validateSearch: expenseApprovalSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Expense Approve">
      <Suspense fallback={<PageLoader />}>
        <ExpenseApprovePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
